import { CustomTableLayout } from '@/layouts/CustomTableLayout'
import { ElSkeleton, ElSkeletonItem, ElTableColumn } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { useResponsive } from 'store'
import { HocElTable } from 'ui-components'
import './QuoteSkeleton.scss'

export const QuoteSkeleton = defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    rowCount: {
      type: Number,
      default: 14,
    },
  },
  setup(props, { slots }) {
    const { t } = useI18n()
    const responsive = useResponsive()
    const commonSkeleton = () => (
      <ElSkeleton animated loading>
        {{
          template: () => <ElSkeletonItem class="common-skeleton-item" variant={'rect'} />,
        }}
      </ElSkeleton>
    )

    return () => {
      if (props.loading) {
        return (
          <CustomTableLayout>
            <div class="quote-skeleton-layout">
              <HocElTable data={Array.from({ length: props.rowCount }).fill({})} fit>
                <ElTableColumn label={t('交易对')}>
                  {{
                    default: () => (
                      <div class="coin-skeleton">
                        <ElSkeleton animated loading>
                          {{
                            template: () => (
                              <>
                                <ElSkeletonItem class={'avatar-skeleton'} variant={'circle'} />
                                <ElSkeletonItem class={'name-skeleton'} variant={'rect'} />
                              </>
                            ),
                          }}
                        </ElSkeleton>
                      </div>
                    ),
                  }}
                </ElTableColumn>
                {responsive.isMobile && <ElTableColumn />}
                <ElTableColumn label={t('最新价')}>
                  {{
                    default: () => commonSkeleton(),
                  }}
                </ElTableColumn>

                <ElTableColumn label={t(responsive.isMobile ? '涨幅' : '24H涨跌幅')} align={responsive.isMobile ? 'right' : 'left'}>
                  {{
                    default: () => commonSkeleton(),
                  }}
                </ElTableColumn>
                {!responsive.isMobile && (
                  <>
                    <ElTableColumn label={t('24H最高')}>
                      {{
                        default: () => commonSkeleton(),
                      }}
                    </ElTableColumn>
                    <ElTableColumn label={t('24H最低')}>
                      {{
                        default: () => commonSkeleton(),
                      }}
                    </ElTableColumn>
                    <ElTableColumn label={t('24H交易额')}>
                      {{
                        default: () => commonSkeleton(),
                      }}
                    </ElTableColumn>
                    <ElTableColumn label={t('操作')} width={100}>
                      {{
                        default: () => <div class={'btn-skeleton'}>{commonSkeleton()}</div>,
                      }}
                    </ElTableColumn>
                  </>
                )}
              </HocElTable>
            </div>
          </CustomTableLayout>
        )
      }

      return slots.default?.()
    }
  },
})
